/* Carry an already-applied Shopify bundle code into Releasit's native discount field.
   Releasit stacks every valid code it is given, so keep at most one bundle code per order;
   other codes (e.g. RECOVERY DISCOUNT) are left alone.
   No prices, discount rules, app settings, customer fields or orders are changed here. */
(() => {
  'use strict';
  const supported = new Set(['BELABOX4', 'BELABOX6', 'BELASILBF4', 'BELASILBF6']);
  let current = null, scheduled = false, removingAt = 0;
  const plaqueCodes = () => Array.from(document.querySelectorAll('._rsi-modal-discounts-plaque-code'), el => el.textContent.trim().toUpperCase());
  const bundlePlaques = () => plaqueCodes().filter(code => supported.has(code));
  // Remove every bundle code except the cart's own (or, failing that, the first applied).
  function keepSingleBundle() {
    const bundles = bundlePlaques();
    if (bundles.length < 2) return false;
    // Releasit removes a code with a network round trip; don't click the same button again meanwhile.
    if (Date.now() - removingAt < 4000) return true;
    removingAt = Date.now();
    const keep = current?.code && bundles.includes(current.code) ? current.code : bundles[0];
    bundles.filter(code => code !== keep).forEach(code => {
      document.querySelector('._rsi-modal-discounts-plaque-close-button[data-discount-code="' + code + '" i]')?.click();
    });
    message('Poți folosi un singur cod de pachet pe comandă. Am păstrat ' + keep + '; verifică totalul de plată de mai jos.');
    return true;
  }
  function message(text) {
    const form = document.querySelector('._rsi-modal-discounts-form');
    if (!form) return;
    let note = form.querySelector('[data-belasil-discount-note]');
    if (!note) {
      note = document.createElement('p'); note.dataset.belasilDiscountNote = '';
      note.setAttribute('role', 'status'); note.style.cssText = 'font-size:13px;line-height:1.5;color:#282828;padding:10px;background:#fff7cc;border-radius:6px';
      form.append(note);
    }
    if (note.textContent !== text) note.textContent = text;
    note.hidden = !text;
  }
  async function prepare(input) {
    const state = current = {input, code:null, loading:true, attempted:false};
    message('Verificăm oferta pachetului din coș…');
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (current !== state || !input.isConnected) return;
      state.code = (cart.discount_codes || []).find(item => item.applicable !== false && supported.has(item.code.toUpperCase()))?.code.toUpperCase() || null;
      state.loading = false;
      sync();
    } catch (_) {
      if (current !== state) return;
      state.loading = false;
      message('Verifică totalul comenzii. Dacă ai ales un pachet de 4 sau 6 bidoane, aplică aici codul afișat în coș.');
    }
  }
  function sync() {
    const input = document.getElementById('_rsi-modal-discounts-form-code');
    if (!input || !input.getClientRects().length) { current = null; return; }
    if (!current || current.input !== input) { prepare(input); return; }
    const state = current;
    if (state.loading) return;
    if (keepSingleBundle()) return;
    if (!state.code) { message(''); return; }
    if (plaqueCodes().includes(state.code)) { message('Reducerea pachetului este aplicată. Verifică totalul de plată de mai jos.'); return; }
    if (state.attempted) return;
    // Never overwrite a code the visitor has started entering or a different app offer.
    if (input.value.trim() || plaqueCodes().length) {
      message('Ai ales o altă ofertă. Verifică totalul; pentru pachetul din coș folosește codul ' + state.code + '.');
      state.code = null;
      return;
    }
    const apply = document.getElementById('_rsi-modal-discounts-form-apply');
    if (!apply || apply.disabled) return;
    state.attempted = true;
    input.value = state.code;
    input.dispatchEvent(new Event('input', {bubbles:true}));
    input.dispatchEvent(new Event('change', {bubbles:true}));
    message('Aplicăm reducerea pachetului ' + state.code + '…');
    apply.click();
    window.setTimeout(() => {
      if (current === state && input.isConnected && !plaqueCodes().includes(state.code)) {
        message('Reducerea pachetului nu este încă aplicată. Apasă „Activează” lângă ' + state.code + ' și verifică totalul înainte de comandă.');
      }
    }, 7000);
  }
  // Protect against submitting the undiscounted amount while the native app applies the code.
  document.addEventListener('click', event => {
    if (!event.target.closest('._rsi-modal-submit-button')) return;
    if (bundlePlaques().length > 1) {
      event.preventDefault(); event.stopImmediatePropagation();
      keepSingleBundle();
      return;
    }
    if (!current) return;
    if (current.loading || (current.code && !plaqueCodes().includes(current.code))) {
      event.preventDefault(); event.stopImmediatePropagation();
      message('Așteaptă aplicarea reducerii pachetului sau activează codul afișat înainte de a trimite comanda.');
      document.getElementById('_rsi-modal-discounts-form-code')?.focus();
    }
  }, true);
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    // setTimeout, not requestAnimationFrame: rAF is paused in throttled/background tabs.
    setTimeout(() => { scheduled = false; sync(); }, 50);
  });
  observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});
  sync();
  // "Cumpără acum" on the sticky bar adds the package and lands here: open the COD form once.
  let openAt = 0;
  try { openAt = Number(sessionStorage.getItem('belasilOpenCod')) || 0; sessionStorage.removeItem('belasilOpenCod'); } catch (_) {}
  if (openAt && Date.now() - openAt < 60000 && /\/cart\/?$/.test(location.pathname)) {
    let tries = 0;
    const timer = setInterval(() => {
      const button = Array.from(document.querySelectorAll('._rsi-buy-now-button-cart')).find(el => el.getClientRects().length);
      if (button) { clearInterval(timer); button.click(); }
      else if (++tries > 40) clearInterval(timer);
    }, 250);
  }
})();
